var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._m(0), _c('b-tabs', {
    attrs: {
      "pills": ""
    },
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Stok Mobil"
    }
  }, [_c('stok-mobil', {
    ref: "stokMobil",
    on: {
      "submitRetur": _vm.afterSubmitRetur
    }
  })], 1), _c('b-tab', {
    attrs: {
      "title": "Stok Retur"
    }
  }, [_c('retur-konsumen', {
    ref: "returKonsumen"
  })], 1), _c('b-tab', {
    attrs: {
      "title": "Data Pengembalian"
    }
  }, [_c('pengembalian', {
    ref: "pengembalian"
  })], 1)], 1)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-2"
  }, [_c('h4', {
    staticClass: "mb-25"
  }, [_vm._v("Detail Stok Kendaraan")]), _c('p', {
    staticClass: "text-body mb-0"
  }, [_vm._v(" Kelola stok di mobil, lihat retur konsumen, dan pantau request pengembalian stok ke gudang. ")])]);
}]

export { render, staticRenderFns }